export interface Table {
}

export interface AppTableSource {
  rows: AppTableRow[];
  headers: AppTableHeader[];
  length: number;
  pageIndex: number;
  pageSize: number;
  moduleName?:string;
}


export interface AppTableHeader {
  id?:any;
  name?: string;
  value: string;
  type?: TableColumnTypes;
  checked?: boolean,
  actions?: any[];
  sort?: ColumnSortType;
  order?:number;
  align?: string,
  className?:string;
  resizeColumn?:boolean;
  width?: string;
  disabled?: boolean;
  translate?: boolean;
  meta?: string;
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  placeholder?: string;
  /** AVATAR: row key with the name used for the initials/tooltip of app-avatar */
  titleKey?: string;
  /** AVATAR: row key with the presence status (`online`, `offline`, ...) shown as a dot on app-avatar */
  statusKey?: string;
}

export interface AppTableRow {
  position: number;
  data: any;
}

export enum TableColumnTypes {
  TITLE = 'TITLE',
  TEXT = 'TEXT',
  TEXT_TRANSLATE = 'TEXT_TRANSLATE',
  DATE = 'DATE',
  IMAGE = 'IMAGE',
  DATETIME = 'DATETIME',
  CHECKBOX = 'CHECKBOX',
  BOOLEAN = 'BOOLEAN',
  ACTION = 'ACTION',
  OLX_STATUS = 'OLX_STATUS',
  NOVA_POSHTA_STATUS = 'NOVA_POSHTA_STATUS',
  UKR_POSHTA_STATUS = 'UKR_POSHTA_STATUS',
  PHONE = 'PHONE',
  ARRAY_PHONE = 'ARRAY_PHONE',
  ARRAY = 'ARRAY',
  TOGGLE = 'TOGGLE',
  SELECT = 'SELECT',
  TEXT_COPY = 'TEXT_COPY',
  OLX_ADVERT_STATUS = 'OLX_ADVERT_STATUS',
  LINK = 'LINK',
  OLX_IMAGE = 'OLX_IMAGE',
  OLX_PRICE = 'OLX_PRICE',
  PLANNER_STATUS = 'PLANNER_STATUS',
  PLANNER_TYPE = 'PLANNER_TYPE',
  AUDIO = 'AUDIO',
  RINGOSTAT_STATUS = 'RINGOSTAT_STATUS',
  CALL = 'CALL',
  TIME = 'TIME',
  CHANNEL_TYPE = 'CHANNEL_TYPE',
  CHANNEL_STATUS = 'CHANNEL_STATUS',
  PLANNER_V2_STATUS = 'PLANNER_V2_STATUS',
  POWER_OLX_STATUS = 'POWER_OLX_STATUS',
  ERROR_CODE = 'ERROR_CODE',
  DELIVERY_WAYBILL = 'DELIVERY_WAYBILL',
  PRICE = 'PRICE',
  PAYMENT_INFO = 'PAYMENT_INFO',
  PAYMENT_STATUS = 'PAYMENT_STATUS',
  ICON = 'ICON',
  MEMBERSHIP_STATUS = 'MEMBERSHIP_STATUS',
  AVATAR = 'AVATAR',
}

export enum PaymentStatus {
  TODO = 'Todo',
  CREATED = 'CREATED',
  IN_PROCESS = 'IN_PROCESS',
  SUCCESS = 'SUCCESS',
}

export enum ColumnSortType {
  ASC = 'asc',
  DESC = 'desc',
  NONE = 'none'
}

export interface ColumnStatus {
  icon: string;
  text: string;
  color: string;
}
